<div class="mobile-nav-menu d-flex position-fixed flex-column d-lg-none">
  <!-- NAV BAR -->
  <div class="mobile-nav-bar bg-primary d-flex justify-content-between">
    <a class="nav-item fw-bold brand p-0" [routerLink]="['/']" routerLinkActive="router-link-active">
      <label id="homeLink" class="accessibility-only">Go To Home Page</label>
      <img alt="imagedetails" class="home-logo" [src]="'images/fortress-logo-mobile.png' | contentAssetImage" draggable="false" />
    </a>

    <!--Notifications-->
    <div class="right-mobile-nav gap-2 d-flex justify-content-center align-items-center flex-row">
      <div class="nav-item">
        <fgb-notification-button [isMobile]="true"></fgb-notification-button>
      </div>
      <button
        attr.aria-label="{{ 'nav.toggle.screenreader' | translate }}"
        class="nav-item fw-bold navbar-toggler m-0 px-2"
        (click)="isCollapsed = !isCollapsed"
      >
        <span class="icon material-icons material-mobile-nav text-white">menu</span>
      </button>
    </div>
  </div>

  <!-- NAV SCREEN -->
  <div [ngbCollapse]="isCollapsed" class="mobile-nav-menu-dropdown bg-white">
    <div class="d-flex flex-column mobile-nav-menu-content">
      <!-- Close Button -->
      <div class="container header d-flex flex-row justify-content-between align-items-center">
        <img
          alt="imagedetails"
          class="home-logo"
          [src]="'images/fortress-logo-mobile.png' | contentAssetImage"
          draggable="false"
        />
        <button
          class="close-button border-0"
          attr.aria-label="{{ 'modal.close' | translate }}"
          (click)="isCollapsed = !isCollapsed"
        >
          <span class="material-symbols-outlined"> close </span>
        </button>
      </div>

      <!-- Nav Buttons -->
      <div class="container mobile-nav-button-container">
        <a
          class="nav-item fw-bold large-item"
          [routerLink]="['/profile']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="nav-item-title-div">
            <span class="material-icons-outlined text-primary"> account_circle </span>
            <div class="nav-text fw-bold">{{ 'nav.account' | translate }}</div>
          </div>
        </a>

        <a class="nav-item" [routerLink]="['/subscriptions']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
          <div class="nav-item-title-div">
            <span class="material-icons text-primary"> card_membership </span>
            <div class="nav-text fw-bold">{{ 'account.nav.subscriptions' | translate }}</div>
          </div>
        </a>

        <a class="nav-item" [routerLink]="['/rewards']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
          <div class="nav-item-title-div">
            <span class="material-icons"> redeem </span>
            <div class="nav-text fw-bold">{{ 'nav.rewards' | translate }}</div>
          </div>
        </a>

        <a
          class="nav-item"
          [routerLink]="['/challenges-v2']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="nav-item-title-div">
            <span class="material-icons"> emoji_events </span>
            <div class="nav-text fw-bold">{{ 'nav.challenges' | translate }}</div>
          </div>
        </a>

        <a class="nav-item" [routerLink]="['/payment']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
          <div class="nav-item-title-div">
            <span class="material-icons text-primary"> credit_card </span>
            <div class="nav-text fw-bold">{{ 'nav.payment' | translate }}</div>
          </div>
        </a>


        <a class="nav-item" [routerLink]="['/games']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
          <div class="nav-item-title-div">
            <span class="material-icons"> sports_esports </span>
            <div class="nav-text fw-bold">{{ 'nav.games' | translate }}</div>
          </div>
        </a>
        <a
          class="nav-item"
          [routerLink]="['/rewards/wallet']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="nav-item-title-div">
            <fgbcl-wallet-text-with-badge [count]="unredeemedCount">
              <span class="material-icons"> account_balance_wallet </span>
              <div class="nav-text fw-bold">{{ 'nav.wallet' | translate }}</div>
            </fgbcl-wallet-text-with-badge>
          </div>
        </a>

        <a class="nav-item" [routerLink]="['/earn']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
          <div class="nav-item-title-div">
            <span class="material-icons"> loyalty </span>
            <div class="nav-text fw-bold">{{ 'nav.earn' | translate }}</div>
          </div>
        </a>

        <a
          class="nav-item"
          [routerLink]="['/worksheet']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="nav-item-title-div">
            <span class="material-symbols-outlined"> animated_images </span>
            <div class="nav-text fw-bold">{{ 'nav.gallery' | translate }}</div>
          </div>
        </a>

        <div class="help-wrapper">
          <div
            class="nav-item help-dropdown flex-row justify-content-between"
            [ngClass]="{ collapsed: openHelp }"
            (click)="toggleHelp()"
          >
            <div class="help-button d-flex flex-row align-items-center">
              <span class="material-icons text-primary">info</span>
              <span class="nav-text">{{ 'nav.help' | translate }}</span>
            </div>
            <span class="material-icons arrow">expand_more</span>
          </div>

          <ng-container *ngIf="openHelp">
            <div class="help-submenu d-flex flex-column">
              <a
                class="help-item"
                [routerLink]="['/terms']"
                [routerLinkActive]="'active'"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <div class="nav-item-title-div">
                  <div class="nav-text fw-bold">{{ 'nav.terms' | translate }}</div>
                </div>
              </a>
              <a
                class="help-item"
                [routerLink]="['/faq']"
                [routerLinkActive]="'active'"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <div class="nav-item-title-div">
                  <div class="nav-text fw-bold">{{ 'nav.faq' | translate }}</div>
                </div>
              </a>
              <a
                class="help-item"
                [routerLink]="['/contact']"
                [routerLinkActive]="'active'"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <div class="nav-item-title-div">
                  <div class="nav-text fw-bold">{{ 'nav.contact.us' | translate }}</div>
                </div>
              </a>
            </div>
          </ng-container>
        </div>

        <a class="nav-item text-danger logout-link-div" (click)="logout()">
          <i class="material-icons font-size-14 fw-bold">logout</i>
          <div class="nav-text fw-bold">{{ 'nav.log.out' | translate }}</div>
        </a>
      </div>
    </div>
  </div>
</div>
